import React, { /*Component*/ } from 'react';

import {
  scaleForMinimalComponents,
  minimal,
  rangeKeyIncrement,
  largeTreeRangeKeyIncrement,
  largeTreeMaxViewportWidth,
  fullNameFontSize,
  fullNameFontStyle,
  fullNameLineHeight,
  fontFamily,
  isDevelopment,
  dualPedigreeLaunchOnDev,
  defaultBackgroundTextureFileName,
  isSeinfeld,
  dualPedigreeMode,
  stageBackgroundDefaultColor,
  importCustomStylesFromServer,
  midscale,
  subroot,
  debugCallbackFetchResolveAndPopModal,
  presetObj,
  isSafari,
} from '../../library/constants';

import {
  isChrome,
  isFireFox,
  isIE,
  isAndroidTablet,
  isLandscape,
  isAndroidPhone,
  buildFullNameLineArrBasedOnFontSize,
  truncateFullNameLineArrBasedOnFontSize,
  getWidthKonvaText,
  isMobilePhone,
  getNodeFromNodeObjsWithPrId,
  doWhenReady,
  parseOutLastSegmentOfUrl,
  filterQuestionMarkFromURL,
  timer,
  sortVisitedByValueIncrementOne
} from '../../library/calc';


export default class Build extends React.Component{ // eslint-disable-line react/prefer-stateless-function

  constructor(props){
    super(props);


    // setTimeout(() => {
    //   // this.showDebugLog();
    // }, 15000);


    if( props.unit_test ){
      Object.assign(this, props);
      Object.assign(this.props, props);
    }

    // console.log('Build: React.createRef');
    this.stage = React.createRef();
    this.fanChartComponent                       = React.createRef();

    this.sessionTimer = timer();
    this.sessionTimer.start();

    this.visited                                 = {};
    this.debugObj                                = {};
    this.debugOrder                               = 0;
    this.currentNotNull                          = undefined;
    this.currentIsDefined                        = undefined;
    this.userClickerBackOrFowardButton           = 'false';
    this.popedUrlAddress                         = [];
    this.enabledStageDraggingCount                = 0;

    this.mouseMoveDisabled                       = false;
    this.touchStartScale                         = 1;
    this.arrOfPhotos                             = [];
    this.touchMoveDisabled                       = false;
    this.matchBubbleAppears                      = false;
    // this.props.focusNode                               = null;
    this.didRequestReLoadTree                    = false;
    this.flipPanelOpenAfterAnimateComplete       = false;
    this.didOnlyOnceAfterStateHasTree            = false;
    this.showFlipNodeMobileAfterZoomIn           = false;
    this.isZooming                               = false;
    this.keyPressEnabled                         = true;
    this.stageCanBeClickedTouchedHovered         = true;
    this.stageClickCanCloseFlipPanel             = true;
    this.stageClickCanZoomStep                   = true;
    this.componentUpdateAfterStateFirstHasTree   = false;
    this.canHideInviteModal                      = true;
    this.continueWithTouchSpot                   = false;
    this.stageTouchmoved                         = false;
    this.nodeCanBeClicked                        = true;
    this.velocityCanBeRequested                  = true;
    this.ok2clear                                = true;
    this.zoomQueueArray                          = [];
    this.redraw_scaleX_compare_start_value       = null;
    this.redraw_scaleX_compare_end_value         = null;
    this.redraw_upon_zoom_comparison_initialized = false;
    this.pageProfilesObj                         = {};
    this.curZoomScaleBeforeClick                 = 0;
    this.curNodeBeforeClick                      = 0;
    this.documentTouchMovePreventDefault         = false;
    this.zoomedFocusCompleteAfterInitialTreeLoad = false;
    this.cntrlDragNode                         = undefined;
    this.dropOnGhostConfirming                   = false;
    this.isDraggingFloater                       = false;
    this.allowBashChangeToPan                    = false;
    this.ieAddedScrollBarWidthFloaters           = 15;
    this.decisionChoicesArray                    = [];
    this.farthestRightNode                       = 0;
    this.farthestLeftNode                        = 0;
    this.requestFetchForAllProfiles              = false;
    this.isProductTourWithFirstMaleGhostAndStartStepAtOne = false;
    this.productTourStepLaunchAfterFetch         = false;
    this.fanChartObj                             = {}
    this.highlightNodes                          = [];
    this.state = {
      clearImgCache              : 6254533,
      show_ancestors            : false,
      refreshGotoList            : false,
      boolTest                   : false,
      gotoComponentEnabled       : false,
      flipNodeCrumbs             : [],
      allProfilesFetched         : false,
      pedigreeAddboxVisible      : false,
      pedigreeAddboxLeft         : null,
      pedigreeAddboxTop          : null,
      pedigreeAddboxNode         : null,
      isPedigreeDev              : true,
      resolveIsVisable           : false,
      printModalVisible          : false,
      showSwitchOtherIcons        : false,
      highResolutionImagesForDualPedigree          : false,
      showPrintMobile             : false,
      printFlipCardVisible      : false,
      treeIsVisable              : true,
      sliderValue                : 10,
      bubbleWidth                : undefined,
      shiftLeftOnToolTip         : undefined,
      shiftTopOnToolTip          : undefined,
      placementShownInToolTip    : null,
      nodeShownInMatchBubble     : null,
      contentShownInToolTip      : null,
      runTranslatePhraseInToolTip: null,
      translateVarStrInToolTip   : null,
      toolTipDelay               : undefined,
      okLabelInToolTip           : undefined,
      confirmLabelInToolTip      : undefined,
      okLabelWidthInToolTip      : undefined,
      confirmLabelWidthInToolTip : undefined,
      okCallbackInToolTip        : undefined,
      confirmCallbackInToolTip   : undefined,
      nodeShownInToolTip         : null,
      flipPanelOpened            : false,
      navigationPanelIsUp        : false,
      gotoNavTabActive           : false,
      mapNavTabActive            : false,
      nodeForFlipFocus           : null,
      showMobileFlipCard         : false,
      showSlideUpImmediateFamily : false,
      showSlideUpAddSourceCitation : false,
      showMobileLegend : false,
      flipCardScreenIsOn         : `mainFromHome`,
      whichSideTip               : `left`,
      showInviteModal            : false,
      showLegendModal            : false,
      modalOpen                  : false,
      dualPedigreeModalOpen      : false,
      dualPedigreeModalOpenChangeName      : false,
      dualPedigreeModalOpenChangeWhichField      : undefined,
      cropNode                   : 0,
      whichModalScreen           : null,
      nextNodeForPruning         : null,  // Used for hiding every other node except nextNodeForPruning in animation when user clicks Prune Tree icon
      pushToHistory              : false,
      showProgressIndicator      : false,
      showTreeOverlay            : false,
      showNavigationalControls   : false,
      inviteNode                 : null,
      invitePrId                 : null,
      inviteFullName             : null,
      // antMobileModal             : true,
      onMobileConfirm            : null,
      onMobileOk                 : null,
      showConfirmMobile          : false,
      mobileConfirmContent       : '',
      mobileConfirmLabel         : '',
      mobileOkLabel              : '',
      reloadCanvasTree           : false,
      prIdToRedraw               : undefined,
      prIdToTeleport             : undefined,
      cacheBreakPics             : false,
      dragNodeObj                : {},
      moveMode                   : 'findDragNode',
      dropOnNode                 : null,
      moveOperationWithCtrlKeyDnActivated        : false,
      showFloaterPanel           : false,
      moveDecisionPanelVisible   : false,
      showMoveHelp               : false,
      productTourVisible         : false,
      placeholderImage_m         : null,
      placeholderImage_f         : null,
      placeholderImage_u         : null,
      matchBubbleContent         : undefined,
      matchBubbleContentVarStr   : undefined,
      resolvePrId                : undefined,
      firstNodeWithPrune         : undefined,
      moveDecisionPanelPos:{
        left: 0,
        top : 0,
      },
      moveHelpPos:{
        right: 267,
        top: typeof(this.props) !== 'undefined' ? this.props.canvasTop: 63,
      },
      addExistObj:{
        floater_profile_id: null,
        focusPrid: null,
        dropOnPrId: null,
        floaterFirstName: null,
        floaterGender: null,
      },
      warnPublic: false,
      firstTreeMatchCountNotify: false,
      firstRecordMatchCountNotify: false,
      profilesAllFetchedForFirstGhostNodeNeighbors: false,
      autoStepping: false,
      prIdForWarning: undefined,
      nodeObjPosForInformModal: {},
      lastStepNotifySeen: false,
      firstMatchCountNodeSeen: false,
      maleCustomColor:  undefined,
      femaleCustomColor: undefined,
      unGenderedCustomColor: undefined,
      stageBackgroundCustomColor: undefined,
      fontSizeChoice:  undefined,
      maxWidth:  undefined,
      shadeLevel:  -30,
      selectedtheme: undefined,
      showCardPhotos: undefined,
      showCardEditIcon: undefined,
      showCardEmailInvite: undefined,
      innerFrameSideLengthAdjust: 0,
      innerFrameSideDownAdjust: 0,
      innerFrameSideRightAdjust: 0,
      unionIdDualPedigreeChoice: undefined,
      dualPedigreePanelTabOn: ( dualPedigreeLaunchOnDev ? 'twoTab':  'oneTab'),
      //dualPedigreePanelTabOn: 'twoTab',
      //dualPedigreeCollapseChoice: '1',
      dualPedigreePanelOpened: true,
      dualPedigreeBackgroundTextureFileName: defaultBackgroundTextureFileName,
      downloadingPedigreeChart: false,
    };

    window.thisTree = this
    window.thisTreeState = this.state;
    window.thisTreeVisited = sortVisitedByValueIncrementOne(this.visited);

    window.seeDebugTree = () => {

      console.log(`{}: `, JSON.stringify({
        enabledStageDraggingCount: this.enabledStageDraggingCount,
        minimal,
        isSafari,
        isChrome: isChrome(),
        isFireFox: isFireFox(),
        isIE: isIE(),
        isAndroidTablet: isAndroidTablet(),
        isLandscape: isLandscape(),
        isAndroidPhone: isAndroidPhone(),
        sessionTook: this.sessionTimer.stop(),
        currentNotNull: this.currentNotNull,
        currentIsDefined: this.currentIsDefined,
        userClickerBackOrFowardButton: this.userClickerBackOrFowardButton,
        popedUrlAddress: this.popedUrlAddress,
        visitedCount: this.visitedCount,
        visited: sortVisitedByValueIncrementOne(this.visited),
      }, null, 2));
    }

    window.seeNode = (node) => {

      const conditionsAre = () => {
        return typeof(window.nodeObjs) !== undefined;
      }

      const doThis = () => {
        if (node) console.log(`nodeObjs: `, JSON.stringify(window.nodeObjs[node], null, 2))
        else console.log(`nodeObjs: `, JSON.stringify(window.nodeObjs, null, 2))
      }

      doWhenReady({argument: '', condition: conditionsAre, callback: doThis, attempts: {ongoing:0, end: 99999999}, fromWhere: 'seeNode'})

    }

    if( isSeinfeld){
      if(document.querySelector(`#static_notice`) !== null) document.querySelector(`#static_notice`).style.display = 'none'
      if(document.querySelector(`#active_notice`) !== null) document.querySelector(`#active_notice`).style.display = 'none'
      if(document.querySelector(`#facebook-jssdk-iframe`) !== null) document.querySelector(`#facebook-jssdk-iframe`).style.display = 'none'
    }




  }

  shouldUpdate = true;
  shouldComponentUpdate(nextProps, nextState) {
    return this.shouldUpdate;
  }

  allowComponentUpdate(bool){
    if(typeof(bool) === 'undefined' ){
      this.shouldUpdate = ( this.shouldUpdate === false ? true: false)
    } else {
      this.shouldUpdate = bool;
    }
  }

  forceUpdateCanvas(fromWhere){

    clearTimeout(this.debounceForceUpdateCanvas);
    this.debounceForceUpdateCanvas = setTimeout(() => {
      console.count('forceUpdateCanvas complete: ', fromWhere);
      this.forceUpdate();
    }, 800);

  }

  reloadWithNewTree({
    prId,
    node,
    disableNextNodeForPruning,
    triggerPedigreeAddNodeTab,
    triggerDefaultTreeAddNodeTab,
    fromWhere,
  }){

    this.visitedCount++; this.visited['reloadWithNewTree'] = this.visitedCount;

    // console.log(`fromWhere: `, fromWhere);

    /*
     *
     * Only called from flipPanel ... icon action
     * Also called from reloadingTreeWithBackOrFowardButton
     * This method is the same as in /src/components/Prune/index.js and flipcard
     * Duplicating this method because of a bug where props.fetchTree suddenly disappears
     * Will continue at componentDidUpdate ... new state means new props means componentDidUpdate
     *
     *
     *
     */

    if(!isMobilePhone() && !dualPedigreeMode) {
      this.resetNavDirectionControls();
      this.toggleFlipPanel({close: true, from: 'loadPruneTree'});
      // toggleNavigationalPanel({direction: 'down'});
      this.resetNavigationState();
      this.unhighlight();
    }

    this.showProgressIndicator({fromWhere: 'Canvas->reloadWithNewTree'});
    this.setDidRequestLoadTreeToTrue('canvas load prune tree');
    if(typeof(this.props.setPrId) === 'function') this.props.setPrId(prId); else {console.log('setPrId is not a prop');}
    if(typeof(this.props.fetchTree) === 'function'){
      this.props.fetchTree({
          callback: () => {
            this.callSetPageProfile(prId, this.props.nodeObjs, 'canvas.js reloadWithNewTree');

            if(triggerDefaultTreeAddNodeTab){

              setTimeout(() => {
                this.onclickedAddNodeTab(this.props.focusNode);
              }, 2000);

            }

            if(triggerPedigreeAddNodeTab){
              this.refs[`node-tab-${this.props.focusNode}`].triggerClick();
            }

            const { newPrunesObj } = this.gatherNodesToFetchMoreData({all: false,});
            this.fetchPrunesOnlyAfterDelay({newPrunesObj})

          },
          fromWhere: 'reloadWithNewTree'
      });
    } else {console.log('fetchTree is not a prop');}
    if(typeof(disableNextNodeForPruning) === 'undefined') this.setNextNodeForPruning(node); else {/*console.log('setNextNodeForPruning is not a prop');*/}
  }

  continueFromReloadwithNewTree(){
    this.visitedCount++; this.visited['continueFromReloadwithNewTree'] = this.visitedCount;

    this.props.fetchPreferences({});
    this.resetCanvasDimensions();
    this.setTreeVisible(true);

    this.dropOnGhostConfirming = false;
    this.unsetNextNodeForPruning();
    this.didRequestReLoadTree = false;
    this.resetFetchedAllProfiles();
    if(!dualPedigreeMode){
      this.toggleNavigationalPanel({direction: 'down'});
      this.toggleFlipPanel({close: true, from: 'continueFromReloadwithNewTree'});
    }
    this.enableTouchmove();

    this.hideProgressIndicator();
    this.fetchFloaters();

    if(this.state.reloadCanvasTree || this.state.warningPublicRequested){

        this.continueToTeleportFromExternalRedrawTree();

    } else{
      if(this.props.isPedigree){

        if(typeof(this.state.prIdToTeleport) !== 'undefined' ){
          const teleportNode = getNodeFromNodeObjsWithPrId({
              nodeObjs: this.nodeObjs,
              prId: this.state.prIdToTeleport,
              fromWhere: 'continueFromReloadwithNewTree'
          })

          if(typeof(teleportNode) === 'undefined'){
            this.redrawTreeWhenSecondParmNodeNotFoundInFetch();
          }

        }

        this.teleportToPedigreeCenter({fromWhere:'continueFromReloadwithNewTree'});

      } else{

        doWhenReady({
          argument: {},
          condition: ()=>{
            return this.props.focusNode
          },
          callback: () =>{

            let teleportNode = undefined;

            if(typeof(this.state.prIdToTeleport) !== 'undefined' ){
              teleportNode = getNodeFromNodeObjsWithPrId({
                  nodeObjs: this.nodeObjs,
                  prId: this.state.prIdToTeleport,
                  fromWhere: 'continueFromReloadwithNewTree'
              })

              if(typeof(teleportNode) === 'undefined'){
                this.redrawTreeWhenSecondParmNodeNotFoundInFetch();
              }

            } else{
              teleportNode = this.props.focusNode;
            }

            this.teleportToNode(teleportNode);
          },
          attempts: {ongoing:0, end: 9999999},
          fromWhere: 'continueFromReloadwithNewTree',
        })

      }

    }

  }

  continueToTeleportFromExternalRedrawTree(){

    this.visitedCount++; this.visited['continueToTeleportFromExternalRedrawTree'] = this.visitedCount;

       console.log(`%c continueToTeleportFromExternalRedrawTree`, [
         'color: white',
         'background: orange',
         'font-size: 14px',
         'border: 5px solid red',
         'padding: 10px',
         ].join(';'));


    if(typeof(this.state.prIdToTeleport) !== 'undefined'){

      /*
       *
       *
       *  Test to see if current fetch tree call contains the highlight_pr_id
       *
       */

      const node = getNodeFromNodeObjsWithPrId({nodeObjs: this.nodeObjs, prId: this.state.prIdToTeleport, fromWhere: 'continueToTeleportFromExternalRedrawTree'});

      if(typeof(node) === 'undefined'){

           console.log(`%c redrawTreeWhenSecondParmNodeNotFoundInFetch`, [ // bookmarkPleaseRemove continueToTeleportFromExternalRedrawTree
             'color: white',
             'background: red',
             'font-size: 14px',
             'border: 5px solid red',
             'padding: 10px',
             ].join(';'));


        this.redrawTreeWhenSecondParmNodeNotFoundInFetch();

        return;


      } else {

        if( this.state.warningPublicRequested ) {

          this.launchWarnPublicModal();

        }

      }

      // if(this.props.isPedigree){

      //   if( typeof(this.props.firstTreeMatchCountNode) !== 'undefined'  && !this.state.warningPublicRequested){

      //     this.teleportToNodeForPedigree({ hasFirstTreeMatchCountNode: true });

      //   } else if( typeof(this.props.firstRecordMatchCountNode) !== 'undefined'  && !this.state.warningPublicRequested) {

      //     this.teleportToNodeForPedigree({ hasFirstRecordMatchCountNode: true });

      //   } else {

      //     this.teleportToPedigreeCenter({});
      //     this.unsetRedrawCanvasTree();

      //   }

      // } else{

        if( typeof(this.props.firstTreeMatchCountNode) !== 'undefined' && !this.state.warningPublicRequested){

            this.gotoFocusNode({hasFirstTreeMatchCountNode: true, fromWhere:'1'}); // Using firstTreeMatchCountNode as focusNode

        } else if( typeof(this.props.firstRecordMatchCountNode) !== 'undefined'  && !this.state.warningPublicRequested) {
            this.gotoFocusNode({hasFirstRecordMatchCountNode: true, fromWhere:'2'});  // Using firstRecordMatchCountNode as focusNode

        } else if( typeof(this.state.prIdForWarning) !== 'undefined' ) {

          this.gotoFocusNode({hasNodeForPublicWarning: true, fromWhere:'3'});  // Using nodeForPublicWarning as focusNode

        } else {

          this.teleportToNodeOtherThanFocus();

        }

      // }

    } else{

      this.teleportToFocusNode();

    }

  }

  launchWarnPublicModal(){

    const shouldSetWarningIfNotLaunchingFromPedTabComponent = () => {
      return  ( !this.props.isPedigree )
                ||
              ( this.props.isPedigree && isMobilePhone() )
    };

    const obj = {
      prIdToWarn: this.state.prIdToTeleport,
      showProgressIndicator: false,
      warnPublic: ( shouldSetWarningIfNotLaunchingFromPedTabComponent() ? true: false),
    };

    this.setState(obj);

    const shouldLaunchFromPedigreeTabComponent = () => {
      return  this.props.isPedigree && !isMobilePhone();
    }

    if( shouldLaunchFromPedigreeTabComponent() ){

      this.triggerPedigreeWarningFromPedTabComponent({prIdToTeleport: this.state.prIdToTeleport});

    }
  }

  teleportToFocusNode(){ // redrawTree with focus_pr_id

    this.visitedCount++; this.visited['teleportToFocusNode'] = this.visitedCount;

    const node = getNodeFromNodeObjsWithPrId({nodeObjs: this.nodeObjs, prId: this.state.prIdToRedraw, fromWhere: 'teleportToPrIdToRedraw'});
    const callback = ()=>{
     this.zoomTo({scale: midscale, doSetStateSliderValue: true});
    };

    if(this.props.isPedigree){
      this.teleportToPedigreeCenter({fromWhere:'teleportToFocusNode'});
      this.unsetRedrawCanvasTree();
    } else{
      this.teleportToNode(node, callback);
    }

    this.unsetRedrawCanvasTree();
  }

  teleportToNodeOtherThanFocus(){ // redrawTree with highlight_pr_id
    this.visitedCount++; this.visited['teleportToNodeOtherThanFocus'] = this.visitedCount;
    // console.log('teleportToNodeOtherThanFocus');
    const node = getNodeFromNodeObjsWithPrId({nodeObjs:this.nodeObjs, prId: this.state.prIdToTeleport, fromWhere: 'teleportToPrIdToTeleport'});
    const callback = ()=>{
     this.zoomTo({scale: midscale, doSetStateSliderValue: true})
    };
    this.teleportToNode(node, callback);
    this.unsetRedrawCanvasTree();
  }

  redrawTreeWhenSecondParmNodeNotFoundInFetch(){

    this.visitedCount++; this.visited['redrawTreeWhenSecondParmNodeNotFoundInFetch'] = this.visitedCount;

    this.setState({
      reloadCanvasTree: false,
    });

    setTimeout(() => {

      let message = 'Information';
      let description = "You are being redirected to your newly added profile's branch.";

      if( typeof(window.trl) !== 'undefined' ){
        description = window.trl(description, 'Redirect to new tree notification');
        message = window.trl(message, 'Redirect to new tree notification');
      }

      const type = 'info';
      const duration = 10;

      this.showProgressIndicator();

      this.callHookForMessageAlert({which:'redirectMsg', content: description, title: message, type, duration});

      const param = ( typeof(this.state.prIdToTeleport) !== 'undefined' ? { prIdToTeleport: this.state.prIdToTeleport, cacheBreakPics: true, warnPublic: this.state.warningPublicRequested } : {})

         console.log(`%c Redirect to new tree notification`, [ // bookmarkPleaseRemove redrawTreeWhenSecondParmNodeNotFoundInFetch
           'color: white',
           'background: green',
           'font-size: 14px',
           'border: 5px solid red',
           'padding: 10px',
           ].join(';'));

      this.reloadCanvasTree(this.state.prIdToTeleport, param)

    }, 500);

  }

  pushToHistoryAfterComponentUpdate(){

    this.visitedCount++; this.visited['pushToHistoryAfterComponentUpdate'] = this.visitedCount;

    let newFocusPrId;
    let url;
    if( !this.props.isFanChart ) {
      newFocusPrId = this.nodeObjs[this.props.focusNode].pr_id;
      url = subroot + '/' + newFocusPrId;
    } else {
      newFocusPrId = this.props.focusPrId;
      url = subroot + '/' + newFocusPrId /*+ '?isFanChart=true'*/;
    }

    window.history.pushState(null, "", url);

    let urlAddress = window.location.href;
    // if( !isFanChart ) urlAddress = filterQuestionMarkFromURL(urlAddress);

    window.history.replaceState(null, "", urlAddress);

    if( !this.props.isFanChart ) this.setDocumentTitle(this.nodeObjs[this.props.focusNode]);
    this.unsetPushToHistory();
  }


  afterClickedOnBackOrFowardButton(){

    this.userClickerBackOrFowardButton = 'true';

    this.visitedCount++; this.visited['afterClickedOnBackOrFowardButton'] = this.visitedCount;

    let urlAddress = window.location.href;
    this.popedUrlAddress.push(urlAddress);

    if( urlAddress.includes('#') ) return;
    urlAddress = filterQuestionMarkFromURL(urlAddress);

    const prId = parseOutLastSegmentOfUrl(urlAddress);

    this.closeGeniForms();

    if(isMobilePhone()) this.setShowPrintMobile(false);
    else this.setPrintModalVisible(false);

    if(typeof(window.closePrintCard) !== 'undefined' ) window.closePrintCard();

    this.setState({
      pedigreeAddboxVisible: false,
      treeIsVisable: false,
      warnPublic: false,
      prIdForWarning: undefined,
    });

    this.hideProductTour({fromWhere: 'afterClickedOnBackOrFowardButton', withLastStepNotify: true});
    this.toggleNavigationalPanel({direction: 'down'});
    this.toggleFlipPanel({close: true, from: 'afterClickedOnBackOrFowardButton'});

    const disableNextNodeForPruning = true;

    if(isMobilePhone()) {

      this.setState({
        nodeForFlipFocus: null,
        showMobileFlipCard: false,
        modalIsDisplayed: false,
      });

      this.reloadWithNewTree({prId, disableNextNodeForPruning, fromWhere: 'reloadingTreeWithBackOrFowardButton1'});

      this.touchMoveDisabled = false;

    } else{

      if( dualPedigreeMode){
        console.log('Disabled reloadingTreeWithBackOrFowardButton');
        return;
      }

      this.reloadWithNewTree({prId, disableNextNodeForPruning, fromWhere: 'reloadingTreeWithBackOrFowardButton2'});

    }

  }

  doEveryRenderWheneverStateHasTree(){

    this.visitedCount++; this.visited['doEveryRenderWheneverStateHasTree'] = this.visitedCount;

    this.assembleTree();
    this.focusNodeObj = this.props.nodeObjs[this.props.focusNode];
    this.doOnlyOnceAfterStateHasTree();
  }

  doOnlyOnceAfterStateHasTree(){

    this.visitedCount++; this.visited['doOnlyOnceAfterStateHasTree'] = this.visitedCount;

    if( !this.didOnlyOnceAfterStateHasTree){

      this.stageCenteredNodePosX = this.props.nodeObjs[this.props.focusNode].left;
      this.stageCenteredNodePosY = this.props.nodeObjs[this.props.focusNode].top;

      this.resetCanvasDimensions();


      if(!this.didRequestReLoadTree) {
        this.setDocumentTitle(this.props.nodeObjs[this.props.focusNode]);
        this.componentUpdateAfterStateFirstHasTree = true;
      }

    }

  }

  doAfterInitialComponentUpdateAfterStateHasTree(){

    this.visitedCount++; this.visited['doAfterInitialComponentUpdateAfterStateHasTree'] = this.visitedCount;

    this.hideProgressIndicator();
    this.showNavigationalControls();

    const href = window.location.href;
    const hashPrId = href.split('#')[1];
    const resolveFocusPrId = href.split('?resolve=')[1];
    const needToResolveAndPopModal = () => {
      return typeof(hashPrId) !== 'undefined' ||
        typeof(resolveFocusPrId) !== 'undefined';
    }

    if( needToResolveAndPopModal() &&  !dualPedigreeMode){

      const node = getNodeFromNodeObjsWithPrId({
        nodeObjs:this.nodeObjs,
        prId: ( typeof(resolveFocusPrId) !== 'undefined' ? resolveFocusPrId :hashPrId),
        fromWhere: 'doAfterInitialComponentUpdateAfterStateHasTree'
      });

      if(typeof(node) !== 'undefined') {

        if(debugCallbackFetchResolveAndPopModal) {
          console.log(`resolveFocusPrId: `, resolveFocusPrId);
          console.log(`node: `, node);
        }

        const callbackFetchResolveAndPopModal = () => {
          if(typeof(resolveFocusPrId) !== 'undefined') {
            if(debugCallbackFetchResolveAndPopModal) console.log('Inside callbackFetchResolveAndPopModal .... ');
            this.fetchResolveAndPopModal({prId: resolveFocusPrId});
          } else {}
        }
        this.gotoHashNode({node, callbackFetchResolveAndPopModal})}

      else{

        this.gotoFocusNode({fromWhere:'1'});

      }

    } else {

      const { newPrunesObj } = this.gatherNodesToFetchMoreData({all: false,});
      if( typeof(this.props.firstTreeMatchCountNode) !== 'undefined' && !dualPedigreeMode){

        if(this.props.isPedigree ){
          this.fetchPrunesOnlyAfterDelay({newPrunesObj})
          // this.teleportToNodeForPedigree({ hasFirstTreeMatchCountNode: true });
        } else if(!this.props.isPedigree) {
          if(!isDevelopment) this.props.fetchPreferences({});
        }
        this.gotoFocusNode({hasFirstTreeMatchCountNode: true, fromWhere:'4'}); // Using firstTreeMatchCountNode as focusNode

      } else if( typeof(this.props.firstRecordMatchCountNode) !== 'undefined' && !dualPedigreeMode) {

        if(this.props.isPedigree ){
          this.fetchPrunesOnlyAfterDelay({newPrunesObj})
          // this.teleportToNodeForPedigree({ hasFirstRecordMatchCountNode: true });
        } else if(!this.props.isPedigree) {
          if(!isDevelopment) this.props.fetchPreferences({});
        }
        this.gotoFocusNode({hasFirstRecordMatchCountNode: true, fromWhere:'5'});  // Using firstRecordMatchCountNode as focusNode

      } else {

        if(this.props.isPedigree){

          this.fetchPrunesOnlyAfterDelay({newPrunesObj})
          this.teleportToPedigreeCenter({fromWhere:'doAfterInitialComponentUpdateAfterStateHasTree'});

        } else{

          const callbackAfterPreferenceFetch = ({ show_guide, guide_page }) => {


            if( show_guide && !isMobilePhone()) {

              setTimeout(() => {
                this.showProductTourAfterStateHasTree({ fromWhere: 'O'});
              }, 400);


            } else {

              /*


                 Do when tree is loading normal


               */

               this.gotoFocusNode({fromWhere:'6'});

            }

          }

          if(!isDevelopment) this.props.fetchPreferences({callbackAfterPreferenceFetch});
          else{
            this.gotoFocusNode({fromWhere:'7'});
          }
        }
      }
    }

    setTimeout(() => {

      if(!isDevelopment) this.fetchFloaters();
      else if( !isMobilePhone() ) window.forceUpdateCanvas('FOO');

/*
      const callbackWhenEverFloatersExist = () => {
        if(!minimal) {
          this.setShowFloaterPanel(true);
          this.buildChoicesArray();
        }
      }

      if(typeof(this.props.fetchFloaters) === 'function') this.props.fetchFloaters({callbackWhenEverFloatersExist});
*/

    }, 1000);

    setTimeout(() => {
      this.devAutoStart();

      // const canvasDom = document.querySelector('#canvas');
      // console.log(`canvasDom : `, canvasDom.offsetTop);

    }, 1000);

  }


  getStageBackgroundColor(){

    let stageBackgroundColor = stageBackgroundDefaultColor;
    let repeat = undefined;
    let size = undefined;
    let position = undefined;

    if( typeof(this.state.stageBackgroundCustomColor) !== 'undefined' &&  !dualPedigreeMode ){
      stageBackgroundColor = this.state.stageBackgroundCustomColor;
    } else if(dualPedigreeMode){
      stageBackgroundColor =  'white'
    } else if( importCustomStylesFromServer !== null && typeof(importCustomStylesFromServer) !== 'undefined' ){

      const parsedImportCustomStylesVersions = JSON.parse(importCustomStylesFromServer);
      let parsedImportCustomStyles = parsedImportCustomStylesVersions[1];

      let presetCustomObj = { ...presetObj,
        custom: {
          malePresetColor: "",
          femalePresetColor: "",
          unGenderedPresetColor: "",
          stageBackgroundPresetColor: ""
        }
      }

      if( typeof(parsedImportCustomStyles) !== 'undefined' && typeof(parsedImportCustomStyles.custom) !== 'undefined' ){

        presetCustomObj = { ...presetObj,
          custom: {
            malePresetColor: parsedImportCustomStyles.custom.maleCustomPresetColor,
            femalePresetColor: parsedImportCustomStyles.custom.femaleCustomPresetColor,
            unGenderedPresetColor: parsedImportCustomStyles.custom.unGenderedCustomPresetColor,
            stageBackgroundPresetColor: parsedImportCustomStyles.custom.stageBackgroundCustomPresetColor
          }
        }

        stageBackgroundColor = presetCustomObj[parsedImportCustomStyles.selectedtheme].stageBackgroundPresetColor;

      }


    }

    return {
      stageBackgroundColor,
      repeat,
      size,
      position,
    };

  }

  changeShadeLevel(shadeLevel){
    this.setState({
      shadeLevel
    })
  }

  setMaxWidthFullNameRow(maxWidth){
    this.setState({maxWidth})
  }

  setMaxLineLengthFullNameRow(lineLength){
    this.setState({lineLength})
  }

  buildFullNameRowsBasedOnFontSize({nm, n}){

    if( typeof(nm) === 'undefined' || nm === '') return [];

    const isPedigree = this.props.isPedigree;

    let fullnameArrBasedOnFontSize = buildFullNameLineArrBasedOnFontSize({ isPedigree, fontSizeChoice: this.state.fontSizeChoice, nm, n });
    fullnameArrBasedOnFontSize = truncateFullNameLineArrBasedOnFontSize( { isPedigree, fontSizeChoice: this.state.fontSizeChoice, fullnameArrBasedOnFontSize, lineLength: this.state.lineLength, n } );

    return fullnameArrBasedOnFontSize;
  }

  buildViewPortNodes({viewPortSides}){


    let viewPortNodes = undefined;
    let viewPortNodesChunks = undefined;
    let leftRange = undefined;
    let rightRange = undefined;
    let keyIncrement = undefined;

    if( this.props.isLargeTree ){

      let {left, right } = viewPortSides;

      const width = right - left;
      // console.log(`width: `, width);

      if( width > largeTreeMaxViewportWidth ) {
        const lessBuffer = ((largeTreeMaxViewportWidth - width) * -1) / 2;
        // console.log(`lessBuffer: `, lessBuffer);
        left += lessBuffer;
        right -= lessBuffer;
      }

      viewPortSides = { left, right };

      viewPortNodes = [];
      viewPortNodesChunks = [];
      leftRange = ( Math.ceil( viewPortSides.left/largeTreeRangeKeyIncrement ) * largeTreeRangeKeyIncrement ) - largeTreeRangeKeyIncrement;
      rightRange = ( Math.ceil( viewPortSides.right/largeTreeRangeKeyIncrement ) * largeTreeRangeKeyIncrement ) + largeTreeRangeKeyIncrement;
      keyIncrement = largeTreeRangeKeyIncrement;

    } else {

      viewPortNodes = [];
      viewPortNodesChunks = [];
      leftRange = ( Math.ceil( viewPortSides.left/rangeKeyIncrement ) * rangeKeyIncrement ) - rangeKeyIncrement;
      rightRange = ( Math.ceil( viewPortSides.right/rangeKeyIncrement ) * rangeKeyIncrement ) + rangeKeyIncrement;

      keyIncrement = rangeKeyIncrement;
    }

/*
    if( this.leftRange !== leftRange ) {
      this.leftRange = leftRange;
    }

    if( this.rightRange !== rightRange ) {
      this.rightRange = rightRange;
    }
*/

    // console.log(`{leftRange, rightRange}: `, JSON.stringify({leftRange, rightRange}, null, 2));
    for (let rangeKey = leftRange; rangeKey <= rightRange; rangeKey += keyIncrement) {
      // console.log(`rangeKey: `, rangeKey);
      if(typeof(this.props.nodeObjsByRange[rangeKey]) !== 'undefined' ){
        // console.log(`this.props.nodeObjsByRange[${rangeKey}].nodeObjsArray: `, JSON.stringify(this.props.nodeObjsByRange[rangeKey].nodeObjsArray, null, 2));
        viewPortNodesChunks = this.props.nodeObjsByRange[rangeKey].nodeObjsArray.map((nodeObj) =>{
          return nodeObj.n
        })
        viewPortNodes.push(...viewPortNodesChunks);
      }
    }

    // return [];
    return { viewPortNodes }/*[...new Set(viewPortNodes)]*/;

  }

  showNodeOnTree(node){
    return (
      this.state.nextNodeForPruning === null ||
      this.state.nextNodeForPruning === node
    )
  }

  hideNodeComponentsWhenInviting(node){
    return (
      this.state.inviteNode === node
    )
  }

  needEmailFromNode(getEmail){
    if(isDevelopment) return true;
    return /*isDevelopment || */ (!minimal  && typeof(getEmail) !== 'undefined' && parseInt(getEmail, 10) === 1);
  }

  nodeIsDeadPerson({nodeObj, n}){
    return typeof(nodeObj.l) === 'undefined' && nodeObj.nt !== 'ghost' && this.showNodeOnTree(n) && !this.hideNodeComponentsWhenInviting(n) && typeof(nodeObj.nvp) === 'undefined'
  }

  nodeIsGhost({nodeObj, n}){
    const isGhost = typeof(nodeObj.nt ) !== 'undefined'  && nodeObj.nt === 'ghost'
    return isGhost;
  }

  isBlogIframe(){
    return typeof(minimal) !== 'undefined'
  }

  canAddnode({nodeObj}){
    if(isDevelopment) return true;
    if(this.state.productTourVisible && !minimal && typeof(nodeObj.a) === 'undefined' ) return true;
    return !minimal  && typeof(nodeObj.a) !== 'undefined' && nodeObj.a === 1;
  }

  optionShowPic(){
    return this.props.preferences.get('showCardPhotos');
  }

  canShowPruneTree({nodeObj}){
    if(isDevelopment) return true;
    if( nodeObj.p === '-') return false;
    return typeof(nodeObj.nvt) === 'undefined'
  }

  canClickTreeLink({nodeObj}){
    if(isDevelopment) return true;
    return typeof(nodeObj.nvt) === 'undefined'
  }

  canShowDateAlive({nodeObj}){

      // return false;
    if( this.props.isPedigree && nodeObj.pedigreeIsTall && nodeObj.fullNameLineArr.length > 2){
      return false;
    } else if ( this.props.isPedigree && !nodeObj.pedigreeIsTall && nodeObj.fullNameLineArr.length > 1 ){
      return false;
    }
    else if (
      !this.props.isPedigree && nodeObj.fullNameLineArr.length > 3
    ){

          // if(nodeObj.prId === '6000000085984001969'){

          //     console.log('returning false');

          // }

      return false;
    }

    const fontSize = fullNameFontSize;
    const fontStyle = fullNameFontStyle;
    const lineHeight = fullNameLineHeight;

    let widthOfDateAlive = getWidthKonvaText({str: nodeObj.dateAlive, fontSize, fontFamily, fontStyle, lineHeight})

    if( !this.props.isPedigree && typeof(nodeObj.g_e) === 'undefined'){
      return true;
    } else if( this.props.isPedigree && typeof(nodeObj.g_e) === 'undefined' && widthOfDateAlive <= 55 ){
      return true;
    }

    const fullNameRowsBasedOnFontSize = this.buildFullNameRowsBasedOnFontSize({nm: nodeObj.nm});
    if( !this.props.isPedigree &&
        typeof(nodeObj.g_e) !== 'undefined'
        && fullNameRowsBasedOnFontSize.length === 3){
      return false;
    }

    if( !this.props.isPedigree && typeof(nodeObj.g_e) !== 'undefined' && widthOfDateAlive <= 33){
      return true;
    }

    if( dualPedigreeMode){
      return true
    }
/*

    if(nodeObj.prId === '6000000051183533112'){


      if(typeof(window.doThisOnce) === 'undefined') window.doThisOnce = false;

      if(!window.doThisOnce){
        window.doThisOnce = true;
        console.clear();
        console.log(`widthOfDateAlive: `, widthOfDateAlive);
        console.log(`typeof(nodeObj.g_e): `, typeof(nodeObj.g_e));
        console.log(`nodeObj.fullNameLineArr.length: `, nodeObj.fullNameLineArr.length);
        console.log(`nodeObj: `, JSON.stringify(nodeObj, null, 2));
        console.log(`!this.props.isPedigree: `, !this.props.isPedigree);
        console.log(`nodeObj.fullNameLineArr.length > 3: `, nodeObj.fullNameLineArr.length > 3);

      }
    }

    if(nodeObj.prId === '6000000085984001969'){

        console.log(`widthIs: `, widthIs);

        console.log('returning false at end');

    }

 */
    return false;
  }

  canShowHyperlinkOut(nvp){
    return typeof(nvp) === 'undefined'
  }

  hasDna({nodeObj}){
    if(isDevelopment) return true;
    // return true;
    return typeof(nodeObj.dna) !== 'undefined' && nodeObj.dna === 1;
  }

  hasGedcom({nodeObj}){
    if(isDevelopment) return true;
    // return true;
    return (typeof(nodeObj.gc) !== 'undefined') /*|| isDevelopment*/;
  }

  canShowCycleCount({nodeObj}){
    return !this.canShowResolveWarning({nodeObj}) &&
        !this.canShowPendingMerge({nodeObj}) &&
        !this.canShowInconsistency({nodeObj})
  }

  canShowResolveWarning({nodeObj}){
    // if(isDevelopment) return true;
    return !minimal  && ((typeof(nodeObj.prc) !== 'undefined' && nodeObj.prc === 1) ||
               (typeof(nodeObj.ptc) !== 'undefined' && nodeObj.ptc === 1));
  }

  canShowInconsistency({nodeObj}){
    // if(isDevelopment) return true;
    if( this.canShowResolveWarning({nodeObj})) return false;
    return (!minimal  && typeof(nodeObj.inc) !== 'undefined' && nodeObj.inc > 0);
  }

  canShowPendingMerge({nodeObj}){
    if( this.canShowResolveWarning({nodeObj})) return false;
    if( this.canShowInconsistency({nodeObj})) return false;
    return (!minimal  && typeof(nodeObj.m_p) !== 'undefined' && nodeObj.m_p === 1);
  }

  canEditnode({nodeObj}){
    if(isDevelopment) return true;
    return !minimal  && typeof(nodeObj.e) !== 'undefined' && nodeObj.e === 1;
  }

  nodeIsPresumedDeadPerson({nodeObj, n}){
    return typeof(nodeObj.l) !== 'undefined' && parseInt(nodeObj.l, 10) === 2 && this.showNodeOnTree(n) && !this.hideNodeComponentsWhenInviting(n)
  }

  showDelete(){
    return false;
  }

  onlyShowWhenScaleAbove(){

    const scaleX = this.stage.current.scaleX();
    if(scaleX > scaleForMinimalComponents/* || this.isZooming*/){
      return true;
    }
    return false;
  }

  canChangeDifferentParent(nodeObj){
    // console.log(`nodeObj.npu: `, nodeObj.npu);
    return !minimal  && typeof(nodeObj.npu) !== 'undefined';
  }

  isPedigreePlaceHolder({nodeObj}){
    return (typeof(nodeObj.isPedigreePlaceHolder) !== 'undefined' && nodeObj.isPedigreePlaceHolder)
  }

  showWhenPedigreeStateFalseOrNodeIsPedigree({nodeObj}){
    return !this.props.isPedigree || (typeof(nodeObj.isPedigree) !== 'undefined' && nodeObj.isPedigree );
  }

/*
  buildFullNameComponentsArray({props, nodeObj}){

    if(this.onlyShowWhenScaleAbove() && this.showNodeOnTree(nodeObj.n) && !this.hideNodeComponentsWhenInviting(nodeObj.n) && !this.nodeIsGhost({nodeObj, n: nodeObj.n}) && this.showWhenPedigreeStateFalseOrNodeIsPedigree({nodeObj})) {
      const fullnameProps = {
        ...props,
        nodeObjs: this.props.nodeObjs,
        scaleX:this.stage.current.scaleX(),
      }

      const assembledFullNameArrayOfOne = assembleFullNameForOneNode(fullnameProps);
      return [...this.FullNameComponentsArray, ...assembledFullNameArrayOfOne];
    };

    return [];
  }
*/


}
